import {
  APP_NOTIFICATIONS_ID
} from './constants';
import AppNotifications from './AppNotifications';

export default AppNotifications;
export { APP_NOTIFICATIONS_ID };
